var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":require("../assets/img/loading.gif"),"alt":""}}),_c('p',[_vm._v("加载中，请稍后...")])])])
}]

export { render, staticRenderFns }